import fetchJsonp from 'fetch-jsonp'
import { API_MAP_QQ_DOMAIN, TENCENT_MAP_KEY } from '../config'

const url =
  process.env.NODE_ENV != 'development'
    ? 'https://apis.map.qq.com'
    : API_MAP_QQ_DOMAIN

// 通过终端设备IP地址获取其当前所在地理位置 https://lbs.qq.com/service/webService/webServiceGuide/webServiceIp
export const getDeviceLocation = () => {
  return fetchJsonp(
    `${url}/ws/location/v1/ip?key=${TENCENT_MAP_KEY}&output=jsonp`,
    {
      headers: { Accept: 'application/json' },
    }
  ).then((response) => response.json())
}

// 文字地址到经纬度的转换能力
export const getGeocoderlocation = (address) => {
  return fetchJsonp(
    `${url}/ws/geocoder/v1?key=${TENCENT_MAP_KEY}&address=${address}&output=jsonp`,
    {
      headers: { Accept: 'application/json' },
    }
  ).then((response) => response.json())
}

// 经纬度到文字地址相关位置信息的转换能力
export const getLocationForAddress = (lat, lng) => {
  return fetchJsonp(
    `${url}/ws/geocoder/v1?key=${TENCENT_MAP_KEY}&location=${lat},${lng}&get_poi=1&poi_options=radius=500;policy=5&output=jsonp`,
    {
      headers: { Accept: 'application/json' },
    }
  ).then((response) => response.json())
}



// WEBPACK FOOTER //
// ./src/api/clubInfo.js